import { AppBundle } from './app-bundles';

const LOCAL_STORAGE_PREFIX = 'hydra-use-external-ui:';

export const APP_EXTERNAL_UI_URLS = {
  [AppBundle.Journeys]: 'https://cio-external-uis.s3.amazonaws.com/journeys/entrypoint.js',
  [AppBundle.DesignStudio]: 'https://cio-external-uis.s3.amazonaws.com/design-studio/entrypoint.js',
};

function isAppBundle(value: string): value is AppBundle {
  return Object.values(AppBundle).some((app) => app === value);
}

export function getAppExternalOverrides(): Record<AppBundle, boolean> {
  const localStorageExternalOverrides: Record<AppBundle, boolean> = {
    [AppBundle.Journeys]: false,
    [AppBundle.DesignStudio]: false,
  };

  for (const key in localStorage) {
    if (key.startsWith(LOCAL_STORAGE_PREFIX)) {
      const app = key.replace(LOCAL_STORAGE_PREFIX, '');
      if (isAppBundle(app)) {
        localStorageExternalOverrides[app] = localStorage[key] === 'true';
      }
    }
  }

  return localStorageExternalOverrides;
}

export function setAppExternalOverride(app: AppBundle, enabled: boolean) {
  localStorage.setItem(`${LOCAL_STORAGE_PREFIX}${app}`, enabled.toString());
}
